import { Avatar, Col } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import * as classes from "./ProfileAvatar.module.scss";

const ProfileAvatar = (props) => {
  const { profilePicture, firstName, lastName, customClass, ...rest } = props;
  const firstNameInitial = firstName.slice(0, 1).toUpperCase();
  const lastNameInitial = lastName.slice(0, 1).toUpperCase();

  return (
    <Col>
      {profilePicture === null ? (
        <Avatar
          {...rest}
          className={classNames(classes.defaultAvatar, customClass)}
        >
          {firstNameInitial}
          {lastNameInitial}
        </Avatar>
      ) : (
        <Avatar
          className={classNames(classes.defaultAvatar, customClass)}
          {...rest}
          src={profilePicture.url}
        ></Avatar>
      )}
    </Col>
  );
};

ProfileAvatar.propTypes = {
  size: PropTypes.number,
  profilePicture: PropTypes.object,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  customClass: PropTypes.string,
};

ProfileAvatar.defaultProps = {
  size: 30,
  profilePicture: {},
  firstName: "",
  lastName: "",
  customClass: "",
};

export default ProfileAvatar;
